const appointmentDetailConstants = {
    APPOINTMENT_CANCEL_BY_ID_REQUEST: 'APPOINTMENT_CANCEL_BY_ID_REQUEST',
    APPOINTMENT_CANCEL_BY_ID_SUCCESS: 'APPOINTMENT_CANCEL_BY_ID_SUCCESS',
    APPOINTMENT_CANCEL_BY_ID_FAILURE: 'APPOINTMENT_CANCEL_BY_ID_FAILURE',
    APPOINTMENT_CANCEL_RESET: 'APPOINTMENT_CANCEL_RESET'
};

export default appointmentDetailConstants;